import { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function LangSwitcher() {
  const { lang, setLang, langs } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const cur = langs.find(l => l.code === lang) || langs[0];
  return (
    <div className="relative" ref={ref}>
      <button onClick={()=>setOpen(!open)} className="btn-ghost" data-testid="lang-switcher">
        <Globe size={16}/>
        <span className="hidden sm:inline text-xs uppercase tracking-widest">{cur.code}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-[200px] card shadow-xl z-50 overflow-hidden" data-testid="lang-panel">
          {langs.map(l => (
            <button key={l.code} onClick={()=>{ setLang(l.code); setOpen(false); }}
              data-testid={`lang-${l.code}`}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[#F2F2F0] ${l.code===lang ? "bg-[#FAFAFA]":""}`}>
              <span className="text-base">{l.flag}</span>
              <span className="flex-1 text-left">{l.label}</span>
              {l.code === lang && <Check size={14}/>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
